import React from "react";
import Select from "react-select";
import { CheckCircle, RotateCw, Cpu, XCircle } from "react-feather";
import { FormSettingsSeparator } from "../../Components/Common/Form/FormSeparator";
import { Loader } from "../../Components/Loader";
import { getCaseSetup, postCaseSetup } from "../../api/simulationApi";
import { downloadBlobAsync } from "../../api/storageApi";
import DeleteModal from "../../Components/Common/DeleteModal/index";
import { HelpCircle } from "react-feather";
import { selectSetupStyle } from "../../Components/Common/PaletteDropdown/index";
import { selectCaseSimulationNotifications } from "../../redux/selectors/simulationSelector";
import {
  setPrecursorCase,
  setWindTurbineMode,
  setNzSetting,
  setNz,
  setstretchLevel,
  setStretchFactor,
  setDzMax,
  setHeightAuto,
  setWindProfileSettingsMode,
  setUComponentOfGeostrophicWind,
  setVComponentOfGeostrophicWind,
  setHubHeight,
  setWindSpeedAtHubHeight,
  setWindDirectionAtHubHeight,
  setTemperatureProfile,
  setSubstanceProfile,
  setRotorTable,
  setRotorSpeed,
  setYawAngle,
  setRotorPlaneTiltAngle,
  setGeneratorRatedMechanicalPower,
  setActivateSpeedControl,
  setActivatePitchControl,
  setActivateYawControl,
  setYawActuatorSpeed,
  setDragCoefficientTower,
  setTangentialLengthOfRotorSegments,
  setRadialWidthOfRotorSegments,
  setNumberOfAirfoils,
  setRoughnessLengthDomain,
  setSurfaceHeatflux,
  setRayleighDampingHeight,
  setRayleighDampeningFactor,
  setIntertialOscillationDampeningFactor,
  setCanopyDragCoefficient,
  setWallHeatfluxTopSurface,
  setCoresInXDirection,
  setCoresInYDirection,
  setSimulationDuration,
  setNetcdfDataFormat,
  setSkipTimeBeforeDataOutput,
  setTimeIntervalRunControlOutput,
  setTimeIntervalDataOutput,
  setTimeIntervalAverageDataOutput,
  setTimeIntervalTimeseriesOutput,
  setTimeIntervalProfilesOutput,
  setTimeInterval3DOutput,
  setAveragingInterval,
  setTimePeriodForAveraging,
  setAveragingIntervalForProfiles,
  setTimePeriodForProfilesAveraging,
  loadWindTurbineSettings,
  loadSavedWindTurbineSettings,
  resetWindTurbineSettings,
  setSectionYZ,
  setSectionXZ,
  setMaskOverSurface,
  setWindTurbinePoiOptions,
  setWindTurbinePoiSelected,
  setWindTurbineWindTurbineOptions,
  setWindTurbineWindTurbineSelected,
  setWindTurbineDataLoaded,
  setPrecursorCaseOptions,
} from "../../redux/actions/windTurbineActions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class WindTurbineSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      saveCompleted: false,
      isResetSettingsModalVisible: false,
      fallbackLoaded: false,
      isInitialLoadComplete: false,
      isTranslationReady: false,
      hasSavedSettings: false,
    };

    this.saveCaseSetup = this.saveCaseSetup.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.resetSettings = this.resetSettings.bind(this);
    this.goToSimulation = this.goToSimulation.bind(this);
    this.handleWindTurbineModeChange =
      this.handleWindTurbineModeChange.bind(this);
    this.handleAveragingIntervalChange =
      this.handleAveragingIntervalChange.bind(this);
    this.handleTimePeriodForAveragingChange =
      this.handleTimePeriodForAveragingChange.bind(this);
    this.handleTimePeriodForAveragingBlur =
      this.handleTimePeriodForAveragingBlur.bind(this);
    this.handleAveragingIntervalForProfilesChange =
      this.handleAveragingIntervalForProfilesChange.bind(this);
    this.handleTimePeriodForProfilesAveragingChange =
      this.handleTimePeriodForProfilesAveragingChange.bind(this);
    this.handleTimePeriodForProfilesAveragingBlur =
      this.handleTimePeriodForProfilesAveragingBlur.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  async loadPoiDataFromGeoJson(geoJsonUrl) {
    if (!geoJsonUrl) return [];

    try {
      const geoJsonResponse = await downloadBlobAsync(geoJsonUrl);
      const geoJson = geoJsonResponse.data;

      return geoJson.features
        .filter((feature) => feature.properties.t === 9)
        .map((feature) => ({
          value: `POI ${feature.properties.id}`,
          label: `POI ${feature.properties.id}`,
          id: feature.properties.id,
          type: "poi",
        }));
    } catch (error) {
      return [];
    }
  }

  async loadWindTurbineDataFromGeoJson(geoJsonUrl) {
    if (!geoJsonUrl) return [];

    try {
      const geoJsonResponse = await downloadBlobAsync(geoJsonUrl);
      const geoJson = geoJsonResponse.data;

      return geoJson.features
        .filter((feature) => feature.properties.t === 10)
        .map((feature) => ({
          value: `WT ${feature.properties.id}`,
          label: `Wind Turbine ${feature.properties.id}`,
          id: feature.properties.id,
          type: "windturbine",
        }));
    } catch (error) {
      return [];
    }
  }

  async loadPoiDataFromDrawnGeoJson(drawnGeoJsonUrl) {
    if (!drawnGeoJsonUrl) return [];

    try {
      const drawnGeoJsonResponse = await downloadBlobAsync(drawnGeoJsonUrl);
      const drawnGeoJson = drawnGeoJsonResponse.data;

      return drawnGeoJson.features
        .filter((feature) => feature.properties.t === 9)
        .map((feature) => ({
          value: `POI ${feature.properties.id}`,
          label: `POI ${feature.properties.id}`,
          id: feature.properties.id,
          type: "poi",
        }));
    } catch (error) {
      return [];
    }
  }

  async loadWindTurbineDataFromDrawnGeoJson(drawnGeoJsonUrl) {
    if (!drawnGeoJsonUrl) return [];

    try {
      const drawnGeoJsonResponse = await downloadBlobAsync(drawnGeoJsonUrl);
      const drawnGeoJson = drawnGeoJsonResponse.data;

      return drawnGeoJson.features
        .filter((feature) => feature.properties.t === 10)
        .map((feature) => ({
          value: `WT ${feature.properties.id}`,
          label: `Wind Turbine ${feature.properties.id}`,
          id: feature.properties.id,
          type: "windturbine",
        }));
    } catch (error) {
      return [];
    }
  }

  async updateNamesWithPolygonData(mapData, polygonDataUrl) {
    if (!polygonDataUrl) return mapData;

    try {
      const polygonDataResponse = await downloadBlobAsync(polygonDataUrl);
      const polygonData = polygonDataResponse.data;

      return mapData.map((item) => {
        const matchingPolygon = polygonData.find(
          (polygon) =>
            polygon.name && item.value.includes(polygon.id.toString())
        );

        if (matchingPolygon) {
          return {
            ...item,
            value: matchingPolygon.name,
            label: matchingPolygon.name,
          };
        }

        return item;
      });
    } catch (error) {
      return mapData;
    }
  }

  isTranslationReady() {
    const { i18n } = this.props;
    return (
      i18n.isInitialized &&
      i18n.language &&
      i18n.hasResourceBundle(i18n.language, "translation") &&
      !i18n.isLoading
    );
  }

  async waitForTranslation() {
    return new Promise((resolve) => {
      const checkTranslation = () => {
        if (this.isTranslationReady()) {
          this.setState({ isTranslationReady: true });
          resolve();
        } else {
          setTimeout(checkTranslation, 50);
        }
      };
      checkTranslation();
    });
  }

  handleWindTurbineModeChange(selectedOption) {
    this.props.setWindTurbineMode(selectedOption);

    if (
      selectedOption.value === "FullRun" &&
      this.props.precursorCaseOptions.length > 0 &&
      !this.props.windTurbine.precursorCase?.value
    ) {
      this.props.setPrecursorCase(this.props.precursorCaseOptions[0]);
    }
  }

  async loadPrecursorCaseOptions() {
    const { caseDetailsDto } = this.props;
    if (!caseDetailsDto || !Array.isArray(caseDetailsDto)) {
      return [];
    }

    const precursorCases = [];

    try {
      const caseChecks = await Promise.all(
        caseDetailsDto.map(async (caseItem) => {
          try {
            const caseSetup = await getCaseSetup(caseItem.id);
            console.log(caseSetup);
            if (
              typeof caseSetup !== "string" &&
              caseSetup.setup?.settings?.wind_turbine_parameters?.mode ===
              "Precursor"
            ) {
              return {
                label: caseItem.name,
                value: caseItem.id,
              };
            }
            return null;
          } catch (error) {
            return null;
          }
        })
      );

      caseChecks.forEach((caseOption) => {
        if (caseOption) {
          precursorCases.push(caseOption);
        }
      });

      console.log("Found precursor cases:", precursorCases);
      return precursorCases;
    } catch (error) {
      console.error("Error loading precursor case options:", error);
      return [];
    }
  }

  async loadAllPoiAndWindTurbineData() {
    const { currentCase } = this.props;
    if (!currentCase) return { poiData: [], windTurbineData: [] };

    const [
      drawnPoiData,
      geoJsonPoiData,
      drawnWindTurbineData,
      geoJsonWindTurbineData,
    ] = await Promise.all([
      this.loadPoiDataFromDrawnGeoJson(currentCase.drawnGeojsonUrl),
      this.loadPoiDataFromGeoJson(currentCase.geojsonUrl),
      this.loadWindTurbineDataFromDrawnGeoJson(currentCase.drawnGeojsonUrl),
      this.loadWindTurbineDataFromGeoJson(currentCase.geojsonUrl),
    ]);

    const allPoiData = [...drawnPoiData, ...geoJsonPoiData];

    const allWindTurbineData = [
      ...drawnWindTurbineData,
      ...geoJsonWindTurbineData,
    ];

    const updatedPoiData = await this.updateNamesWithPolygonData(
      allPoiData,
      currentCase.polygonDataUrl
    );
    const updatedWindTurbineData = await this.updateNamesWithPolygonData(
      allWindTurbineData,
      currentCase.polygonDataUrl
    );

    return {
      poiData: updatedPoiData,
      windTurbineData: updatedWindTurbineData,
      allData: [...updatedPoiData, ...updatedWindTurbineData],
    };
  }

  validateTimePeriodForAveraging(timePeriod, averagingInterval) {
    const timePeriodNum = parseFloat(timePeriod);
    const averagingIntervalNum = parseFloat(averagingInterval);

    if (averagingIntervalNum <= 0) {
      return timePeriodNum === 0;
    }

    return timePeriodNum <= averagingIntervalNum;
  }

  validateTimePeriodForProfilesAveraging(timePeriod, averagingInterval) {
    const timePeriodNum = parseFloat(timePeriod);
    const averagingIntervalNum = parseFloat(averagingInterval);

    if (averagingIntervalNum <= 0) {
      return timePeriodNum === 0;
    }

    return timePeriodNum <= averagingIntervalNum;
  }

  handleAveragingIntervalChange(e) {
    const newValue = e.target.value;
    this.props.setAveragingInterval(newValue);

    if (
      !this.validateTimePeriodForAveraging(
        this.props.windTurbine.timePeriodForAveraging,
        newValue
      )
    ) {
      setTimeout(() => {
        this.props.setTimePeriodForAveraging(0);
      }, 0);
    }
  }

  handleTimePeriodForAveragingChange(e) {
    const newValue = e.target.value;
    this.props.setTimePeriodForAveraging(newValue);

    const averagingInterval = this.props.windTurbine.averagingInterval;
    if (
      newValue &&
      !this.validateTimePeriodForAveraging(newValue, averagingInterval)
    ) {
      setTimeout(() => {
        this.props.setTimePeriodForAveraging(0);
      }, 0);
    }
  }

  handleTimePeriodForAveragingBlur(e) {
    const newValue = e.target.value;
    const averagingInterval = this.props.windTurbine.averagingInterval;

    if (!this.validateTimePeriodForAveraging(newValue, averagingInterval)) {
      this.props.setTimePeriodForAveraging(0);
    }
  }

  handleAveragingIntervalForProfilesChange(e) {
    const newValue = e.target.value;
    this.props.setAveragingIntervalForProfiles(newValue);

    if (
      !this.validateTimePeriodForProfilesAveraging(
        this.props.windTurbine.timePeriodForProfilesAveraging,
        newValue
      )
    ) {
      setTimeout(() => {
        this.props.setTimePeriodForProfilesAveraging(0);
      }, 0);
    }
  }

  handleTimePeriodForProfilesAveragingChange(e) {
    const newValue = e.target.value;
    this.props.setTimePeriodForProfilesAveraging(newValue);

    const averagingIntervalForProfiles =
      this.props.windTurbine.averagingIntervalForProfiles;
    if (
      newValue &&
      !this.validateTimePeriodForProfilesAveraging(
        newValue,
        averagingIntervalForProfiles
      )
    ) {
      setTimeout(() => {
        this.props.setTimePeriodForProfilesAveraging(0);
      }, 0);
    }
  }

  handleTimePeriodForProfilesAveragingBlur(e) {
    const newValue = e.target.value;
    const averagingIntervalForProfiles =
      this.props.windTurbine.averagingIntervalForProfiles;

    if (
      !this.validateTimePeriodForProfilesAveraging(
        newValue,
        averagingIntervalForProfiles
      )
    ) {
      this.props.setTimePeriodForProfilesAveraging(0);
    }
  }

  handleKeyDown(e, fieldType) {
    const { key } = e;
    const isArrowUp = key === "ArrowUp";
    const isArrowDown = key === "ArrowDown";

    if (isArrowUp || isArrowDown) {
      const currentValue = parseFloat(e.target.value) || 0;
      const step = 1;
      const newValue = isArrowUp ? currentValue + step : currentValue - step;

      let maxValue;
      let averagingInterval;
      if (fieldType === "timePeriodForAveraging") {
        averagingInterval = parseFloat(
          this.props.windTurbine.averagingInterval
        );
        maxValue = averagingInterval - 1;
      } else if (fieldType === "timePeriodForProfilesAveraging") {
        averagingInterval = parseFloat(
          this.props.windTurbine.averagingIntervalForProfiles
        );
        maxValue = averagingInterval - 1;
      }

      if (averagingInterval <= 0) {
        if (currentValue > 0) {
          e.preventDefault();

          if (fieldType === "timePeriodForAveraging") {
            this.props.setTimePeriodForAveraging(0);
          } else if (fieldType === "timePeriodForProfilesAveraging") {
            this.props.setTimePeriodForProfilesAveraging(0);
          }
        }
        return;
      }

      if (currentValue >= maxValue) {
        e.preventDefault();

        if (fieldType === "timePeriodForAveraging") {
          this.props.setTimePeriodForAveraging(0);
        } else if (fieldType === "timePeriodForProfilesAveraging") {
          this.props.setTimePeriodForProfilesAveraging(0);
        }
        return;
      }

      if (newValue >= maxValue) {
        e.preventDefault();

        if (fieldType === "timePeriodForAveraging") {
          this.props.setTimePeriodForAveraging(0);
        } else if (fieldType === "timePeriodForProfilesAveraging") {
          this.props.setTimePeriodForProfilesAveraging(0);
        }
      } else if (newValue < 0) {
        e.preventDefault();
      }
    }
  }

  async componentDidMount() {
    this.fallbackTimeout = setTimeout(() => {
      this.setState({ fallbackLoaded: true });
    }, 5000);

    try {
      await this.waitForTranslation();

      this.props.setWindTurbinePoiOptions([]);
      this.props.setWindTurbinePoiSelected([]);
      this.props.setWindTurbineWindTurbineOptions([]);
      this.props.setWindTurbineWindTurbineSelected([]);
      this.props.setPrecursorCaseOptions([]);

      this.props.setSectionYZ([]);
      this.props.setSectionXZ([]);

      this.props.resetWindTurbineSettings();

      if (this.props.currentCase) {
        console.log(this.props.currentCaseId);
        const [data, precursorCases, windTurbineCaseSetup] = await Promise.all([
          this.loadAllPoiAndWindTurbineData(),
          this.loadPrecursorCaseOptions(),
          getCaseSetup(this.props.currentCaseId),
        ]);

        this.props.setWindTurbinePoiOptions(data.poiData);
        this.props.setWindTurbineWindTurbineOptions(data.windTurbineData);
        this.props.setPrecursorCaseOptions(precursorCases);

        if (
          typeof windTurbineCaseSetup !== "string" &&
          windTurbineCaseSetup.setup?.settings
        ) {
          console.log(
            "Loading saved wind turbine settings:",
            windTurbineCaseSetup.setup.settings
          );
          this.props.loadSavedWindTurbineSettings(
            windTurbineCaseSetup.setup.settings
          );
        }

        await new Promise((resolve) => setTimeout(resolve, 200));

        // If current mode is FullRun but no precursor cases are available or only current case is precursor, switch to Precursor mode
        if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          (precursorCases.length === 0 ||
            (precursorCases.length === 1 &&
              precursorCases[0]?.value === this.props.currentCase?.id))
        ) {
          this.props.setWindTurbineMode({
            value: "Precursor",
            label: "Precursor",
          });
        } else if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          precursorCases.length > 0 &&
          !this.props.windTurbine.precursorCase?.value
        ) {
          // If FullRun mode is selected and there are precursor cases available but no precursor is selected, select the first one
          this.props.setPrecursorCase(precursorCases[0]);
        }
      }
      if (this.props.staticDriverNotifications.length > 0) {
        for (
          let index = this.props.staticDriverNotifications.length - 1;
          index >= 0;
          index--
        ) {
          if (
            this.props.staticDriverNotifications[index].type ===
            "staticDriver" &&
            this.props.staticDriverNotifications[index].body.caseId ===
            this.props.currentCase.id &&
            this.props.staticDriverNotifications[index].body.status === 2
          ) {
            this.setState({ savedStaticDriver: true });
          }
        }
      }
      // Mark that initial load is complete
      this.setState({
        isInitialLoadComplete: true,
      });
    } catch (error) {
      console.error("Error loading wind turbine settings:", error);
      this.props.resetWindTurbineSettings(); // Reset to defaults on error
      this.setState({
        isInitialLoadComplete: true,
      });
    } finally {
      if (this.fallbackTimeout) {
        clearTimeout(this.fallbackTimeout);
        this.fallbackTimeout = null;
      }

      this.props.setWindTurbineDataLoaded(true);
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.currentCase?.id !== prevProps.currentCase?.id) {
      await this.handleCaseChange();
    }
    if (
      this.props.currentCase?.staticDriverJob?.status === "Completed" &&
      !this.state.savedStaticDriver
    ) {
      this.setState({ savedStaticDriver: true });
      return;
    } else if (
      this.props.staticDriverNotifications !==
      prevProps.staticDriverNotifications
    ) {
      if (!this.props.currentCase) {
        return;
      }

      for (
        let index = this.props.staticDriverNotifications.length - 1;
        index >= 0;
        index--
      ) {
        if (
          this.props.staticDriverNotifications[index].type === "staticDriver" &&
          this.props.staticDriverNotifications[index].body.caseId ===
          this.props.currentCase.id &&
          this.props.staticDriverNotifications[index].body.status === 2
        ) {
          this.setState({ savedStaticDriver: true });
          return;
        }
      }
    }
  }

  async handleCaseChange() {
    try {
      this.props.setWindTurbinePoiOptions([]);
      this.props.setWindTurbinePoiSelected([]);
      this.props.setWindTurbineWindTurbineOptions([]);
      this.props.setWindTurbineWindTurbineSelected([]);
      this.props.setPrecursorCaseOptions([]);

      this.props.setSectionYZ([]);
      this.props.setSectionXZ([]);

      if (this.props.currentCase) {
        const [data, precursorCases, windTurbineCaseSetup] = await Promise.all([
          this.loadAllPoiAndWindTurbineData(),
          this.loadPrecursorCaseOptions(),
          getCaseSetup(this.props.currentCaseId),
        ]);

        this.props.setWindTurbinePoiOptions(data.poiData);
        this.props.setWindTurbineWindTurbineOptions(data.windTurbineData);
        this.props.setPrecursorCaseOptions(precursorCases);

        if (
          typeof windTurbineCaseSetup !== "string" &&
          windTurbineCaseSetup.setup?.settings
        ) {
          console.log(
            "Loading saved wind turbine settings for new case:",
            windTurbineCaseSetup.setup.settings
          );
          this.props.loadSavedWindTurbineSettings(
            windTurbineCaseSetup.setup.settings
          );
          this.setState({ hasSavedSettings: true });
        } else {
          this.setState({ hasSavedSettings: false });
        }

        await new Promise((resolve) => setTimeout(resolve, 100));

        if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          (precursorCases.length === 0 ||
            (precursorCases.length === 1 &&
              precursorCases[0]?.value === this.props.currentCase?.id))
        ) {
          this.props.setWindTurbineMode({
            value: "Precursor",
            label: "Precursor",
          });
        } else if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          precursorCases.length > 0 &&
          !this.props.windTurbine.precursorCase?.value
        ) {
          this.props.setPrecursorCase(precursorCases[0]);
        }
      }

      await new Promise((resolve) => setTimeout(resolve, 200));
    } catch (error) {
      console.error("Error loading wind turbine settings for new case:", error);
    }
  }

  componentWillUnmount() {
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
      this.fallbackTimeout = null;
    }

    this.props.setWindTurbineDataLoaded(false);
    this.props.setWindTurbinePoiOptions([]);
    this.props.setWindTurbinePoiSelected([]);
    this.props.setWindTurbineWindTurbineOptions([]);
    this.props.setWindTurbineWindTurbineSelected([]);
    this.props.setPrecursorCaseOptions([]);

    this.props.setSectionYZ({ value: "Empty", label: "Empty" });
    this.props.setSectionXZ({ value: "Empty", label: "Empty" });

    this.props.resetWindTurbineSettings();
  }

  async saveCaseSetup() {
    this.setState({ isSaving: true });
    try {
      const windTurbineSettings = {
        caseId: this.props.currentCaseId,
        settings: {
          initialization_parameters: {
            nz_setting: this.props.windTurbine.nzSetting.value,
            nz: this.props.windTurbine.nz,
            dz_stretch_level: this.props.windTurbine.stretchLevel,
            dz_stretch_level_factor: this.props.windTurbine.StretchFactor,
            dz_max: this.props.windTurbine.dzMax,
            height_auto: this.props.windTurbine.heightAuto,
            nx: this.props.rasterArea?.rasterGridXNumber - 1 || 0,
            ny: this.props.rasterArea?.rasterGridYNumber - 1 || 0,
            resolution: this.props.rasterArea?.rasterGridWidth || 0,
          },
          runtime_parameters: {
            npex: this.props.windTurbine.coresInXDirection,
            npey: this.props.windTurbine.coresInYDirection,
            total_cores:
              this.props.windTurbine.coresInXDirection *
              this.props.windTurbine.coresInYDirection,
            end_time: this.props.windTurbine.simulationDuration,
            netcdf_data_format: this.props.windTurbine.netcdfDataFormat.value,
            skip_time_data_output:
              this.props.windTurbine.skipTimeBeforeDataOutput,
            dt_run_control: this.props.windTurbine.timeIntervalRunControlOutput,
            dt_data_output: this.props.windTurbine.timeIntervalDataOutput,
            dt_data_output_av:
              this.props.windTurbine.timeIntervalAverageDataOutput,
            dt_dots: this.props.windTurbine.timeIntervalTimeseriesOutput,
            dt_dopr: this.props.windTurbine.timeIntervalProfilesOutput,
            dt_do3d: this.props.windTurbine.timeInterval3DOutput,
            section_yz:
              this.props.windTurbine.section_yz?.length > 0
                ? this.props.windTurbine.section_yz
                : [],
            section_xz:
              this.props.windTurbine.section_xz?.length > 0
                ? this.props.windTurbine.section_xz
                : [],
            mask_k_over_surface: this.props.windTurbine.mask_k_over_surface,
            averaging_interval: this.props.windTurbine.averagingInterval,
            dt_averaging_input: this.props.windTurbine.timePeriodForAveraging,
            averaging_interval_pr:
              this.props.windTurbine.averagingIntervalForProfiles,
            dt_averaging_input_pr:
              this.props.windTurbine.timePeriodForProfilesAveraging,
          },
          wind_turbine_parameters: {
            mode: this.props.windTurbine.windTurbineMode.value,
            precursor_case: this.props.rasterArea.precursorCase?.value
              ? {
                value: this.props.rasterArea.precursorCase.value,
                label: this.props.rasterArea.precursorCase.label,
              }
              : null,
            wind_profile_settings_mode:
              this.props.windTurbine.windProfileSettingsMode.value,
            ug: this.props.windTurbine.uComponentOfGeostrophicWind,
            vg: this.props.windTurbine.vComponentOfGeostrophicWind,
            hub_height: this.props.windTurbine.hubHeight,
            wind_speed_hh: this.props.windTurbine.windSpeedAtHubHeight,
            wind_dir_hh: this.props.windTurbine.windDirectionAtHubHeight,
            profile_temperature:
              this.props.windTurbine.temperatureProfile.value,
            profile_subsidance: this.props.windTurbine.substanceProfile.value,
            rotor_table: this.props.windTurbine.rotorTable.value,
            rotor_speed: this.props.windTurbine.rotorSpeed,
            yaw_angle: this.props.windTurbine.yawAngle,
            tilt_angle: this.props.windTurbine.rotorPlaneTiltAngle,
            generator_power_rated:
              this.props.windTurbine.generatorRatedMechanicalPower,
            speed_control: this.props.windTurbine.activateSpeedControl,
            pitch_control: this.props.windTurbine.activatePitchControl,
            yaw_control: this.props.windTurbine.activateYawControl,
            yaw_speed: this.props.windTurbine.yawActuatorSpeed,
            tower_cd: this.props.windTurbine.dragCoefficientTower,
            segment_length_tangential:
              this.props.windTurbine.tangentialLengthOfRotorSegments,
            segment_width_radial:
              this.props.windTurbine.radialWidthOfRotorSegments,
            n_airfoils: this.props.windTurbine.numberOfAirfoils,
            roughness_length: this.props.windTurbine.roughnessLengthDomain,
            surface_heatflux: this.props.windTurbine.surfaceHeatflux,
            rayleigh_damping_height:
              this.props.windTurbine.rayleighDampingHeight,
            rayleigh_dampening_factor:
              this.props.windTurbine.rayleighDampeningFactor,
            inertial_oscillation_damping_factor:
              this.props.windTurbine.intertialOscillationDampeningFactor,
            canopy_drag_coeff: this.props.windTurbine.canopyDragCoefficient,
            wall_heatflux_top_surface:
              this.props.windTurbine.wallHeatfluxTopSurface,
          },
        },
      };
      console.log("Wind turbine settings:", windTurbineSettings);
      await postCaseSetup(windTurbineSettings);

      this.setState({ saveCompleted: true, hasSavedSettings: true });
      setTimeout(() => this.setState({ saveCompleted: false }), 5000);
    } catch (err) {
      console.error("Error saving wind turbine settings:", err);
      // Handle error silently
    } finally {
      this.setState({ isSaving: false });
    }
  }

  openModal() {
    this.setState({ isResetSettingsModalVisible: true });
  }

  closeModal() {
    this.setState({ isResetSettingsModalVisible: false });
  }

  goToSimulation() {
    const { match } = this.props;
    const projectId = match.params.projectId;
    const caseId = match.params.caseId;
    this.props.history.push(`/projects/${projectId}/cases/${caseId}/simulation`);
  }

  async resetSettings() {
    this.props.resetWindTurbineSettings();
    this.setState({
      isResetSettingsModalVisible: false,
      isInitialLoadComplete: false,
      isTranslationReady: false,
      hasSavedSettings: false,
    });

    this.props.setWindTurbineDataLoaded(false);

    await this.reloadComponentData();
  }

  async reloadComponentData() {
    try {
      await this.waitForTranslation();

      this.props.setWindTurbinePoiOptions([]);
      this.props.setWindTurbinePoiSelected([]);
      this.props.setWindTurbineWindTurbineOptions([]);
      this.props.setWindTurbineWindTurbineSelected([]);
      this.props.setPrecursorCaseOptions([]);

      this.props.setSectionYZ([]);
      this.props.setSectionXZ([]);

      if (this.props.currentCase) {
        const [data, precursorCases, windTurbineCaseSetup] = await Promise.all([
          this.loadAllPoiAndWindTurbineData(),
          this.loadPrecursorCaseOptions(),
          getCaseSetup(this.props.currentCaseId),
        ]);

        this.props.setWindTurbinePoiOptions(data.poiData);
        this.props.setWindTurbineWindTurbineOptions(data.windTurbineData);
        this.props.setPrecursorCaseOptions(precursorCases);

        if (
          typeof windTurbineCaseSetup !== "string" &&
          windTurbineCaseSetup.setup?.settings
        ) {
          console.log(
            "Loading saved wind turbine settings:",
            windTurbineCaseSetup.setup.settings
          );
          this.props.loadSavedWindTurbineSettings(
            windTurbineCaseSetup.setup.settings
          );
          this.setState({ hasSavedSettings: true });
        } else {
          this.setState({ hasSavedSettings: false });
        }

        await new Promise((resolve) => setTimeout(resolve, 200));

        if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          (precursorCases.length === 0 ||
            (precursorCases.length === 1 &&
              precursorCases[0]?.value === this.props.currentCase?.id))
        ) {
          this.props.setWindTurbineMode({
            value: "Precursor",
            label: "Precursor",
          });
        } else if (
          this.props.windTurbine.windTurbineMode.value === "FullRun" &&
          precursorCases.length > 0 &&
          !this.props.windTurbine.precursorCase?.value
        ) {
          this.props.setPrecursorCase(precursorCases[0]);
        }
      }

      this.setState({
        isInitialLoadComplete: true,
      });
    } catch (error) {
      console.error("Error reloading wind turbine settings:", error);
      this.props.resetWindTurbineSettings(); // Reset to defaults on error
      this.setState({
        isInitialLoadComplete: true,
      });
    } finally {
      this.props.setWindTurbineDataLoaded(true);
    }
  }

  render() {
    const { t } = this.props;

    if (
      (this.props.dataLoaded === false && !this.state.fallbackLoaded) ||
      !this.state.isInitialLoadComplete ||
      !this.state.isTranslationReady
    ) {
      return <Loader />;
    }

    return (
      <div className="page setup-page" style={{ minWidth: 900 }}>
        <div className="settings-form">
          <div className="wind-wrapper">
            <h2 style={{ fontSize: 28, marginBottom: 12 }}>
              {t("WindTurbineSetup")}
            </h2>

            <FormSettingsSeparator label={t("Mode")} />
            {(this.props.precursorCaseOptions.length === 0 ||
              (this.props.precursorCaseOptions.length === 1 &&
                this.props.precursorCaseOptions[0]?.value ===
                this.props.currentCase?.id)) && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "4px",
                    fontStyle: "italic",
                  }}
                >
                  {this.props.precursorCaseOptions.length === 0
                    ? t("FullRunModeDisabledNoPrecursorCases")
                    : t("FullRunModeDisabledOnlyCurrentCasePrecursor")}
                </div>
              )}
            <label className="form-label user-settings-form-label">
              {t("SelectMode")}
            </label>

            <Select
              isSearchable={false}
              styles={selectSetupStyle}
              options={[
                {
                  label: t("Precursor"),
                  value: "Precursor",
                },
                {
                  label: t("FullRun"),
                  value: "FullRun",
                  isDisabled:
                    this.props.precursorCaseOptions.length === 0 ||
                    (this.props.precursorCaseOptions.length === 1 &&
                      this.props.precursorCaseOptions[0]?.value ===
                      this.props.currentCase?.id),
                },
              ]}
              value={{
                label: t(this.props.windTurbine.windTurbineMode.label),
                value: this.props.windTurbine.windTurbineMode.value,
              }}
              onChange={(e) => this.handleWindTurbineModeChange(e)}
              isDisabled={false}
            />

            {this.props.windTurbine.windTurbineMode.value === "FullRun" && (
              <>
                <label
                  className="form-label user-settings-form-label"
                  style={{ marginTop: "12px" }}
                >
                  {t("PrecursorCase")}
                </label>

                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  value={
                    this.props.windTurbine?.precursorCase
                      ? {
                        label: this.props.windTurbine?.precursorCase?.label,
                        value: this.props.windTurbine?.precursorCase?.value,
                      }
                      : {
                        label: this.props.currentCase?.name,
                        value: this.props.currentCase?.id,
                      }
                  }
                  options={this.props.precursorCaseOptions}
                  onChange={(e) => this.props.setPrecursorCase(e)}
                />
              </>
            )}

            <FormSettingsSeparator label={t("Domain")} />
            <label className="form-label user-settings-form-label">
              {t("GridpointsInZDirection")}
            </label>
            <Select
              isSearchable={false}
              styles={selectSetupStyle}
              options={[
                { value: "Manual", label: t("Manual") },
                { value: "Auto", label: t("Auto") },
              ]}
              value={{
                label: t(this.props.windTurbine.nzSetting.label),
                value: this.props.windTurbine.nzSetting.value,
              }}
              onChange={(e) => this.props.setNzSetting(e)}
              isDisabled={
                this.props.windTurbine.windTurbineMode.value === "FullRun"
              }
            />

            <div style={{ marginBottom: 12 }} />

            <label className="form-label user-settings-form-label">
              {t("Nz")} [-]
            </label>
            <input
              className="setup-input"
              type="number"
              min="100"
              max="5000"
              step="1"
              value={this.props.windTurbine.nz}
              onChange={(e) => this.props.setNz(e.target.value)}
              disabled={
                this.props.windTurbine.windTurbineMode.value !== "Precursor" ||
                this.props.windTurbine.nzSetting.value !== "Manual"
              }
            />

            <label className="form-label user-settings-form-label">
              {t("StretchLevel")} [-]
            </label>
            <input
              className="setup-input"
              type="number"
              min="100"
              max="5000"
              step="1"
              value={this.props.windTurbine.stretchLevel}
              onChange={(e) => this.props.setstretchLevel(e.target.value)}
              disabled={
                this.props.windTurbine.windTurbineMode.value !== "Precursor" ||
                this.props.windTurbine.nzSetting.value !== "Manual"
              }
            />

            <label className="form-label user-settings-form-label">
              {t("StretchFactor")} [-]
            </label>
            <input
              className="setup-input"
              type="number"
              min="1"
              max="1.12"
              step="0.01"
              value={this.props.windTurbine.StretchFactor}
              onChange={(e) => this.props.setStretchFactor(e.target.value)}
              disabled={
                this.props.windTurbine.windTurbineMode.value !== "Precursor" ||
                this.props.windTurbine.nzSetting.value !== "Manual"
              }
            />

            <label className="form-label user-settings-form-label">
              {t("DzMax")} [m]
            </label>
            <input
              className="setup-input"
              type="number"
              min="1"
              max="100"
              step="1"
              value={this.props.windTurbine.dzMax}
              onChange={(e) => this.props.setDzMax(e.target.value)}
              disabled={
                this.props.windTurbine.windTurbineMode.value !== "Precursor" ||
                this.props.windTurbine.nzSetting.value !== "Manual"
              }
            />

            <label className="form-label user-settings-form-label">
              {t("MinHeightDomain")} [m]
            </label>
            <input
              className="setup-input"
              type="number"
              min="100"
              max="5000"
              step="10"
              value={this.props.windTurbine.heightAuto}
              onChange={(e) => this.props.setHeightAuto(e.target.value)}
              disabled={
                this.props.windTurbine.windTurbineMode.value !== "Precursor" ||
                this.props.windTurbine.nzSetting.value !== "Auto"
              }
            />

            {/* Wind Profile Settings */}
            {this.props.windTurbine.windTurbineMode.value === "Precursor" && (
              <>
                <FormSettingsSeparator label={t("WindProfileSettings")} />
                <div style={{ marginBottom: 12 }} />
                <label className="form-label user-settings-form-label">
                  {t("WindProfileSettingsMode")}
                </label>
                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  options={[
                    { value: "Manual", label: t("Manual") },
                    { value: "HubHeight", label: t("HubHeight") },
                  ]}
                  value={{
                    label: t(
                      this.props.windTurbine.windProfileSettingsMode.label
                    ),
                    value: this.props.windTurbine.windProfileSettingsMode.value,
                  }}
                  onChange={(e) => this.props.setWindProfileSettingsMode(e)}
                />
              </>
            )}
            {this.props.windTurbine.windTurbineMode.value === "Precursor" && (
              <>
                <div style={{ marginBottom: 12 }} />

                {this.props.windTurbine.windProfileSettingsMode.value ===
                  "Manual" && (
                    <>
                      <label className="form-label user-settings-form-label">
                        {t("UComponentOfGeostrophicWind")} [m/s]
                      </label>
                      <input
                        className="setup-input"
                        type="number"
                        min="-10"
                        max="10"
                        step="0.01"
                        value={this.props.windTurbine.uComponentOfGeostrophicWind}
                        onChange={(e) =>
                          this.props.setUComponentOfGeostrophicWind(
                            e.target.value
                          )
                        }
                      />

                      <label className="form-label user-settings-form-label">
                        {t("VComponentOfGeostrophicWind")} [m/s]
                      </label>
                      <input
                        className="setup-input"
                        type="number"
                        min="-10"
                        max="10"
                        step="0.01"
                        value={this.props.windTurbine.vComponentOfGeostrophicWind}
                        onChange={(e) =>
                          this.props.setVComponentOfGeostrophicWind(
                            e.target.value
                          )
                        }
                      />
                    </>
                  )}

                {this.props.windTurbine.windProfileSettingsMode.value ===
                  "HubHeight" && (
                    <>
                      <label className="form-label user-settings-form-label">
                        {t("HubHeight")} [m]
                      </label>
                      <input
                        className="setup-input"
                        type="number"
                        min="0"
                        max="500"
                        step="1"
                        value={this.props.windTurbine.hubHeight}
                        onChange={(e) => this.props.setHubHeight(e.target.value)}
                      />

                      <label className="form-label user-settings-form-label">
                        {t("WindSpeedAtHubHeight")} [m/s]
                      </label>
                      <input
                        className="setup-input"
                        type="number"
                        min="0"
                        max="20"
                        step="0.01"
                        value={this.props.windTurbine.windSpeedAtHubHeight}
                        onChange={(e) =>
                          this.props.setWindSpeedAtHubHeight(e.target.value)
                        }
                      />

                      <label className="form-label user-settings-form-label">
                        {t("WindDirectionAtHubHeight")} [°]
                      </label>
                      <input
                        className="setup-input"
                        type="number"
                        min="0"
                        max="359"
                        step="1"
                        value={this.props.windTurbine.windDirectionAtHubHeight}
                        onChange={(e) =>
                          this.props.setWindDirectionAtHubHeight(e.target.value)
                        }
                      />
                    </>
                  )}

                <label className="form-label user-settings-form-label">
                  {t("TemperatureProfile")}
                </label>
                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  options={[
                    { value: "Neutral", label: t("Neutral") },
                    { value: "Stable", label: t("Stable") },
                    { value: "Convective", label: t("Convective") },
                  ]}
                  value={{
                    label: t(this.props.windTurbine.temperatureProfile.label),
                    value: this.props.windTurbine.temperatureProfile.value,
                  }}
                  onChange={(e) => this.props.setTemperatureProfile(e)}
                />
                <div style={{ marginBottom: 12 }} />

                <label className="form-label user-settings-form-label">
                  {t("SubstanceProfile")}
                </label>
                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  options={[
                    { value: "Profile1", label: t("Profile1") },
                    { value: "Profile2", label: t("Profile2") },
                  ]}
                  value={{
                    label: t(this.props.windTurbine.substanceProfile.label),
                    value: this.props.windTurbine.substanceProfile.value,
                  }}
                  onChange={(e) => this.props.setSubstanceProfile(e)}
                />
              </>
            )}

            {this.props.windTurbine.windTurbineMode.value === "FullRun" && (
              <>
                <FormSettingsSeparator label={t("WindTurbineSettings")} />

                <label className="form-label user-settings-form-label">
                  {t("RotorTable")}
                </label>
                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  options={[
                    { value: "Preset1", label: t("Preset1") },
                    { value: "Preset2", label: t("Preset2") },
                  ]}
                  value={{
                    label: t(this.props.windTurbine.rotorTable.label),
                    value: this.props.windTurbine.rotorTable.value,
                  }}
                  onChange={(e) => this.props.setRotorTable(e)}
                />
                <div style={{ marginBottom: 12 }} />

                <label className="form-label user-settings-form-label">
                  {t("RotorSpeed")} [m/s]
                </label>
                <input
                  className="setup-input"
                  type="number"
                  min="0.01"
                  max="10"
                  step="0.01"
                  value={this.props.windTurbine.rotorSpeed}
                  onChange={(e) => this.props.setRotorSpeed(e.target.value)}
                />

                <HelpLabel
                  label={t("YawAngle")}
                  unit={"°"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--yaw_angle`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0"
                  max="360"
                  step="0.1"
                  value={this.props.windTurbine.yawAngle}
                  onChange={(e) => this.props.setYawAngle(e.target.value)}
                />

                <HelpLabel
                  label={t("RotorPlaneTiltAngle")}
                  unit={"°"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--tilt_angle`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0"
                  max="360"
                  step="0.1"
                  value={this.props.windTurbine.rotorPlaneTiltAngle}
                  onChange={(e) =>
                    this.props.setRotorPlaneTiltAngle(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("GeneratorRatedMechanicalPower")}
                  unit={"W"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--generator_power_rated`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="1"
                  max="999999999.9"
                  step="0.1"
                  value={this.props.windTurbine.generatorRatedMechanicalPower}
                  onChange={(e) =>
                    this.props.setGeneratorRatedMechanicalPower(e.target.value)
                  }
                />

                <div
                  style={{
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={this.props.windTurbine.activateSpeedControl}
                    onChange={(e) =>
                      this.props.setActivateSpeedControl(e.target.checked)
                    }
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  />
                  <HelpLabel
                    label={t("ActivateSpeedControl")}
                    helpLink={`${helpUrl}/#wind_turbine_parameters--speed_control`}
                  />
                </div>

                <div
                  style={{
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={this.props.windTurbine.activatePitchControl}
                    onChange={(e) =>
                      this.props.setActivatePitchControl(e.target.checked)
                    }
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  />
                  <HelpLabel
                    label={t("ActivatePitchControl")}
                    helpLink={`${helpUrl}/#wind_turbine_parameters--pitch_control`}
                  />
                </div>

                <div
                  style={{
                    marginBottom: "18px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={this.props.windTurbine.activateYawControl}
                    onChange={(e) =>
                      this.props.setActivateYawControl(e.target.checked)
                    }
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  />
                  <HelpLabel
                    label={t("ActivateYawControl")}
                    helpLink={`${helpUrl}/#wind_turbine_parameters--yaw_control`}
                  />
                </div>

                <HelpLabel
                  label={t("YawActuatorSpeed")}
                  unit={"rad/s"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--yaw_speed`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.000001"
                  max="1"
                  step="0.000001"
                  value={this.props.windTurbine.yawActuatorSpeed}
                  onChange={(e) =>
                    this.props.setYawActuatorSpeed(e.target.value)
                  }
                  disabled={!this.props.windTurbine.activateYawControl}
                />

                <HelpLabel
                  label={t("DragCoefficientTower")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--tower_cd`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0"
                  max="10"
                  step="0.01"
                  value={this.props.windTurbine.dragCoefficientTower}
                  onChange={(e) =>
                    this.props.setDragCoefficientTower(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("TangentialLengthOfRotorSegments")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--segment_length_tangential`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.1"
                  max="99.9"
                  step="0.1"
                  value={this.props.windTurbine.tangentialLengthOfRotorSegments}
                  onChange={(e) =>
                    this.props.setTangentialLengthOfRotorSegments(
                      e.target.value
                    )
                  }
                />

                <HelpLabel
                  label={t("RadialWidthOfRotorSegments")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--segment_width_radial`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.1"
                  max="99.9"
                  step="0.1"
                  value={this.props.windTurbine.radialWidthOfRotorSegments}
                  onChange={(e) =>
                    this.props.setRadialWidthOfRotorSegments(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("NumberOfAirfoils")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#wind_turbine_parameters--n_airfoils`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="1"
                  max="20"
                  step="1"
                  value={this.props.windTurbine.numberOfAirfoils}
                  onChange={(e) =>
                    this.props.setNumberOfAirfoils(e.target.value)
                  }
                />
              </>
            )}

            {/* Parameters */}
            <FormSettingsSeparator label={t("Parameters")} />

            <HelpLabel
              label={t("RoughnessLengthDomain")}
              unit={"m"}
              helpLink={`${helpUrl}/#initialization_parameters--roughness_length`}
            />
            <input
              className="setup-input"
              type="number"
              min="0.1"
              max="10"
              step="0.01"
              value={this.props.windTurbine.roughnessLengthDomain}
              onChange={(e) =>
                this.props.setRoughnessLengthDomain(e.target.value)
              }
            />

            {this.props.windTurbine.windTurbineMode.value === "Precursor" && (
              <>
                <HelpLabel
                  label={t("SurfaceHeatflux")}
                  unit={"K*m/s"}
                  helpLink={`${helpUrl}/#initialization_parameters--surface_heatflux`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.1"
                  max="10"
                  step="0.01"
                  value={this.props.windTurbine.surfaceHeatflux}
                  onChange={(e) =>
                    this.props.setSurfaceHeatflux(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("RayleighDampingHeight")}
                  unit={"m"}
                  helpLink={`${helpUrl}/#initialization_parameters--rayleigh_damping_height`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0"
                  max="5000"
                  step="10"
                  value={this.props.windTurbine.rayleighDampingHeight}
                  onChange={(e) =>
                    this.props.setRayleighDampingHeight(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("RayleighDampeningFactor")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#initialization_parameters--rayleigh_damping_factor`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.01"
                  max="1"
                  step="0.01"
                  value={this.props.windTurbine.rayleighDampeningFactor}
                  onChange={(e) =>
                    this.props.setRayleighDampeningFactor(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("IntertialOscillationDampeningFactor")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#damping_parameters--inertial_oscillation_damping_factor`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.01"
                  max="1"
                  step="0.01"
                  value={
                    this.props.windTurbine.intertialOscillationDampeningFactor
                  }
                  onChange={(e) =>
                    this.props.setIntertialOscillationDampeningFactor(
                      e.target.value
                    )
                  }
                />
              </>
            )}

            {this.props.windTurbine.windTurbineMode.value === "FullRun" && (
              <>
                <HelpLabel
                  label={t("CanopyDragCoefficient")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#plant_canopy_parameters--canopy_drag_coeff`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.01"
                  max="1"
                  step="0.01"
                  value={this.props.windTurbine.canopyDragCoefficient}
                  onChange={(e) =>
                    this.props.setCanopyDragCoefficient(e.target.value)
                  }
                />

                <HelpLabel
                  label={t("WallHeatfluxTopSurface")}
                  unit={"K*m/s"}
                  helpLink={`${helpUrl}/#initialization_parameters--wall_heatflux`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="0.1"
                  max="10"
                  step="0.1"
                  value={this.props.windTurbine.wallHeatfluxTopSurface}
                  onChange={(e) =>
                    this.props.setWallHeatfluxTopSurface(e.target.value)
                  }
                />
              </>
            )}

            <FormSettingsSeparator label={t("Runtime")} />
            <HelpLabel
              label={t("CoresInXDirection")}
              unit={"-"}
              helpLink={`${helpUrl}/#runtime_parameters--npex`}
            />
            <input
              className="setup-input"
              type="number"
              min="1"
              max="1000"
              step="1"
              value={this.props.windTurbine.coresInXDirection}
              onChange={(e) => this.props.setCoresInXDirection(e.target.value)}
            />

            <HelpLabel
              label={t("CoresInYDirection")}
              unit={"-"}
              helpLink={`${helpUrl}/#runtime_parameters--npey`}
            />
            <input
              className="setup-input"
              type="number"
              min="1"
              max="1000"
              step="1"
              value={this.props.windTurbine.coresInYDirection}
              onChange={(e) => this.props.setCoresInYDirection(e.target.value)}
            />

            <label className="form-label user-settings-form-label">
              {t("TotalCores")} [-]
            </label>
            <input
              className="setup-input"
              min="1"
              max="1000"
              step="1"
              value={
                this.props.windTurbine.coresInXDirection *
                this.props.windTurbine.coresInYDirection
              }
              disabled
            />

            <HelpLabel
              label={t("SimulationDuration")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--end_time`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="900"
              value={this.props.windTurbine.simulationDuration}
              onChange={(e) => this.props.setSimulationDuration(e.target.value)}
            />

            <FormSettingsSeparator label={t("DataOutput")} />

            {this.props.windTurbine.windTurbineMode.value === "Precursor" && (
              <>
                <label className="form-label user-settings-form-label">
                  {t("NetcdfDataFormat")}
                </label>
                <Select
                  isSearchable={false}
                  styles={selectSetupStyle}
                  options={[
                    { value: "3", label: "3" },
                    { value: "2", label: "2" },
                    { value: "1", label: "1" },
                  ]}
                  value={{
                    label: this.props.windTurbine.netcdfDataFormat.label,
                    value: this.props.windTurbine.netcdfDataFormat.value,
                  }}
                  onChange={(e) => this.props.setNetcdfDataFormat(e)}
                />
              </>
            )}
            <div style={{ marginBottom: 12 }} />
            <HelpLabel
              label={t("SkipTimeBeforeDataOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--skip_time_data_output`}
            />

            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="900"
              value={this.props.windTurbine.skipTimeBeforeDataOutput}
              onChange={(e) =>
                this.props.setSkipTimeBeforeDataOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeIntervalRunControlOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_run_control`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="5"
              value={this.props.windTurbine.timeIntervalRunControlOutput}
              onChange={(e) =>
                this.props.setTimeIntervalRunControlOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeIntervalDataOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_data_output`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.timeIntervalDataOutput}
              onChange={(e) =>
                this.props.setTimeIntervalDataOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeIntervalAverageDataOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_data_output_av`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.timeIntervalAverageDataOutput}
              onChange={(e) =>
                this.props.setTimeIntervalAverageDataOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeIntervalTimeseriesOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_dots`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.timeIntervalTimeseriesOutput}
              onChange={(e) =>
                this.props.setTimeIntervalTimeseriesOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeIntervalProfilesOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_dopr`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.timeIntervalProfilesOutput}
              onChange={(e) =>
                this.props.setTimeIntervalProfilesOutput(e.target.value)
              }
            />

            <HelpLabel
              label={t("TimeInterval3DOutput")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_do3d`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.timeInterval3DOutput}
              onChange={(e) =>
                this.props.setTimeInterval3DOutput(e.target.value)
              }
            />
            <label className="form-label user-settings-form-label">
              {t("SectionYZ")}
            </label>
            <Select
              isMulti
              isSearchable={false}
              isClearable
              closeMenuOnSelect={false}
              styles={selectSetupStyle}
              placeholder={`${t("Select")}...`}
              options={[
                ...this.props.poiOptions
                  .filter((item) => item.type === "poi")
                  .map((item) => ({
                    value: item.id,
                    label: item.label,
                  })),
                ...this.props.windTurbineOptions
                  .filter((item) => item.type === "windturbine")
                  .map((item) => ({
                    value: item.id,
                    label: item.label,
                  })),
              ]}
              value={this.props.windTurbine.section_yz}
              onChange={(e) => this.props.setSectionYZ(e || [])}
            />
            <div style={{ marginBottom: 12 }} />
            <label className="form-label user-settings-form-label">
              {t("SectionXZ")}
            </label>
            <Select
              isMulti
              isSearchable={false}
              isClearable
              closeMenuOnSelect={false}
              styles={selectSetupStyle}
              placeholder={`${t("Select")}...`}
              options={[
                ...this.props.poiOptions
                  .filter((item) => item.type === "poi")
                  .map((item) => ({
                    value: item.id,
                    label: item.label,
                  })),
                ...this.props.windTurbineOptions
                  .filter((item) => item.type === "windturbine")
                  .map((item) => ({
                    value: item.id,
                    label: item.label,
                  })),
              ]}
              value={this.props.windTurbine.section_xz}
              onChange={(e) => this.props.setSectionXZ(e || [])}
            />
            <div style={{ marginBottom: 12 }} />

            {this.props.windTurbine.windTurbineMode.value === "FullRun" && (
              <>
                <HelpLabel
                  label={t("VerticalOutputLimitAboveTerrain")}
                  unit={"-"}
                  helpLink={`${helpUrl}/#runtime_parameters--mask_k_over_surface`}
                />
                <input
                  className="setup-input"
                  type="number"
                  min="1"
                  max="100"
                  step="1"
                  value={this.props.windTurbine.mask_k_over_surface}
                  onChange={(e) =>
                    this.props.setMaskOverSurface(e.target.value)
                  }
                />
              </>
            )}

            <HelpLabel
              label={t("AveragingInterval")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--averaging_interval`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.averagingInterval}
              onChange={this.handleAveragingIntervalChange}
            />

            <HelpLabel
              label={t("TimePeriodForAveraging")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_averaging_input`}
            />
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "4px",
                fontStyle: "italic",
              }}
            >
              Must be smaller than Averaging Interval (will reset to 0 if
              invalid)
            </div>
            <input
              className="setup-input"
              type="number"
              min="0"
              max="600"
              step="1"
              value={this.props.windTurbine.timePeriodForAveraging}
              onChange={this.handleTimePeriodForAveragingChange}
              onBlur={this.handleTimePeriodForAveragingBlur}
              onKeyDown={(e) => this.handleKeyDown(e, "timePeriodForAveraging")}
            />

            <HelpLabel
              label={t("AveragingIntervalForProfiles")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--averaging_interval_pr`}
            />
            <input
              className="setup-input"
              type="number"
              min="0"
              max="99999.9"
              step="300"
              value={this.props.windTurbine.averagingIntervalForProfiles}
              onChange={this.handleAveragingIntervalForProfilesChange}
            />

            <HelpLabel
              label={t("TimePeriodForProfilesAveraging")}
              unit={"s"}
              helpLink={`${helpUrl}/#runtime_parameters--dt_averaging_input_pr`}
            />
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "4px",
                fontStyle: "italic",
              }}
            >
              Must be smaller than Averaging Interval for Profiles (will reset
              to 0 if invalid)
            </div>
            <input
              className="setup-input"
              type="number"
              min="0"
              max="600"
              step="1"
              value={this.props.windTurbine.timePeriodForProfilesAveraging}
              onChange={this.handleTimePeriodForProfilesAveragingChange}
              onBlur={this.handleTimePeriodForProfilesAveragingBlur}
              onKeyDown={(e) =>
                this.handleKeyDown(e, "timePeriodForProfilesAveraging")
              }
            />

            <div style={{ marginBottom: 20 }}></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: this.state.hasSavedSettings ? "space-between" : "space-around",
                gap: this.state.hasSavedSettings ? "0" : "26px",
              }}
            >
              <button
                className="wizard-button wizard-button-submit"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "34px",
                  width: "auto",
                  backgroundColor: "white",
                  color: "#212121",
                  border: "1px solid #6a6a6a",
                  alignItems: "center",
                }}
                onClick={this.openModal}
              >
                <div style={{ minWidth: 12, display: "flex" }}>
                  <RotateCw size="12" stroke="black" strokeWidth="2" />
                </div>
                <div style={{ display: "flex", marginLeft: "6px" }}>
                  {t("DefaultSettings")}
                </div>
              </button>

              <button
                id="wind-turbine-btn__save"
                className="wizard-button wizard-button-submit"
                onClick={this.saveCaseSetup}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "34px",
                }}
                disabled={
                  this.props.simulationJobs?.length ||
                    this.props.simulationNotifications
                    ? true
                    : false ||
                    (this.props.currentCase?.staticDriverJob?.status !==
                      "Completed" &&
                      !this.state.savedStaticDriver)
                }
              >
                {this.state.isSaving && (
                  <Loader size="x-small" mode="light" />
                )}
                {!this.state.isSaving && <span>{t("Save")}</span>}
              </button>

              {this.state.hasSavedSettings && (
                <button
                  className="wizard-button wizard-button-submit"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "34px",
                    width: "auto",
                    backgroundColor: "white",
                    color: "#212121",
                    border: "1px solid #6a6a6a",
                    alignItems: "center",
                  }}
                  onClick={this.goToSimulation}
                >
                  <div style={{ minWidth: 12, display: "flex" }}>
                    <Cpu size="12" stroke="black" strokeWidth="2" />
                  </div>

                  <div style={{ display: "flex", marginLeft: "6px" }}>
                    {t("Simulation")}
                  </div>
                </button>
              )}
            </div>

            {this.state.saveCompleted && (
              <div className="setup-save-status-wrapper" style={{ marginTop: "20px" }}  >
                <CheckCircle
                  width="17"
                  stroke="rgb(6,137,108)"
                  strokeWidth="2"
                />

                <div className="save-status-text">
                  {t("SetupHasBeenSaved")}
                </div>
              </div>
            )}


            {this.props.simulationJobs?.length ||
              !!this.props.simulationNotifications ? (
              <div className="setup-save-status-wrapper" style={{ marginTop: "20px" }}>
                <XCircle size="17" stroke="#a81d1dcf" strokeWidth="2" />

                <div className="save-status-disabled">
                  {t("SavingSetupDisabledSimStarted")}
                </div>
              </div>
            ) : this.props.currentCase?.staticDriverJob?.status !==
              "Completed" && !this.state.savedStaticDriver ? (
              <div className="setup-save-status-wrapper" style={{ marginTop: "20px" }}>
                <XCircle size="17" stroke="#a81d1dcf" strokeWidth="2" />

                <div className="save-status-disabled">
                  {t("SavingSetupDisabledNoStaticDriver")}
                </div>
              </div>
            ) : (
              <></>
            )}



            <DeleteModal
              isOpen={this.state.isResetSettingsModalVisible}
              modalHdr={t("ResetSetup")}
              closeDeleteModal={this.closeModal}
              modalInfo={t("ResetSetupInfo")}
              deleteModalData={this.resetSettings}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    caseDetailsDto: state.projects?.loadedProject?.caseDetailsDto,
    windTurbine: state.windTurbine,
    currentCase: state.projects.currentCase,
    currentCaseId: state.projects?.currentCaseId,
    allDrawnMapPoiGeoProps: state.map.allDrawnMapPoiGeoProps,
    poiOptions: state.windTurbine.poiOptions,
    selectedPoi: state.windTurbine.selectedPoi,
    windTurbineOptions: state.windTurbine.windTurbineOptions,
    selectedWindTurbine: state.windTurbine.selectedWindTurbine,
    dataLoaded: state.windTurbine.dataLoaded,
    precursorCaseOptions: state.windTurbine.precursorCaseOptions,
    simulationJobs: state.projects?.currentCase?.simulationJobs,
    simulationNotifications: selectCaseSimulationNotifications(state),
    rasterArea: state.rasterArea,
    staticDriverNotifications: state.notifications.notifications,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setWindTurbineMode: (payload) => dispatch(setWindTurbineMode(payload)),
    setPrecursorCase: (payload) => dispatch(setPrecursorCase(payload)),
    setNzSetting: (payload) => dispatch(setNzSetting(payload)),
    setNz: (payload) => dispatch(setNz(payload)),
    setstretchLevel: (payload) => dispatch(setstretchLevel(payload)),
    setStretchFactor: (payload) => dispatch(setStretchFactor(payload)),
    setDzMax: (payload) => dispatch(setDzMax(payload)),
    setHeightAuto: (payload) => dispatch(setHeightAuto(payload)),
    setWindProfileSettingsMode: (payload) =>
      dispatch(setWindProfileSettingsMode(payload)),
    setUComponentOfGeostrophicWind: (payload) =>
      dispatch(setUComponentOfGeostrophicWind(payload)),
    setVComponentOfGeostrophicWind: (payload) =>
      dispatch(setVComponentOfGeostrophicWind(payload)),
    setHubHeight: (payload) => dispatch(setHubHeight(payload)),
    setWindSpeedAtHubHeight: (payload) =>
      dispatch(setWindSpeedAtHubHeight(payload)),
    setWindDirectionAtHubHeight: (payload) =>
      dispatch(setWindDirectionAtHubHeight(payload)),
    setTemperatureProfile: (payload) =>
      dispatch(setTemperatureProfile(payload)),
    setSubstanceProfile: (payload) => dispatch(setSubstanceProfile(payload)),
    setRotorTable: (payload) => dispatch(setRotorTable(payload)),
    setRotorSpeed: (payload) => dispatch(setRotorSpeed(payload)),
    setYawAngle: (payload) => dispatch(setYawAngle(payload)),
    setRotorPlaneTiltAngle: (payload) =>
      dispatch(setRotorPlaneTiltAngle(payload)),
    setGeneratorRatedMechanicalPower: (payload) =>
      dispatch(setGeneratorRatedMechanicalPower(payload)),
    setActivateSpeedControl: (payload) =>
      dispatch(setActivateSpeedControl(payload)),
    setActivatePitchControl: (payload) =>
      dispatch(setActivatePitchControl(payload)),
    setActivateYawControl: (payload) =>
      dispatch(setActivateYawControl(payload)),
    setYawActuatorSpeed: (payload) => dispatch(setYawActuatorSpeed(payload)),
    setDragCoefficientTower: (payload) =>
      dispatch(setDragCoefficientTower(payload)),
    setTangentialLengthOfRotorSegments: (payload) =>
      dispatch(setTangentialLengthOfRotorSegments(payload)),
    setRadialWidthOfRotorSegments: (payload) =>
      dispatch(setRadialWidthOfRotorSegments(payload)),
    setNumberOfAirfoils: (payload) => dispatch(setNumberOfAirfoils(payload)),
    setRoughnessLengthDomain: (payload) =>
      dispatch(setRoughnessLengthDomain(payload)),
    setSurfaceHeatflux: (payload) => dispatch(setSurfaceHeatflux(payload)),
    setRayleighDampingHeight: (payload) =>
      dispatch(setRayleighDampingHeight(payload)),
    setRayleighDampeningFactor: (payload) =>
      dispatch(setRayleighDampeningFactor(payload)),
    setIntertialOscillationDampeningFactor: (payload) =>
      dispatch(setIntertialOscillationDampeningFactor(payload)),
    setCanopyDragCoefficient: (payload) =>
      dispatch(setCanopyDragCoefficient(payload)),
    setWallHeatfluxTopSurface: (payload) =>
      dispatch(setWallHeatfluxTopSurface(payload)),
    setCoresInXDirection: (payload) => dispatch(setCoresInXDirection(payload)),
    setCoresInYDirection: (payload) => dispatch(setCoresInYDirection(payload)),
    setSimulationDuration: (payload) =>
      dispatch(setSimulationDuration(payload)),
    setNetcdfDataFormat: (payload) => dispatch(setNetcdfDataFormat(payload)),
    setSkipTimeBeforeDataOutput: (payload) =>
      dispatch(setSkipTimeBeforeDataOutput(payload)),
    setTimeIntervalRunControlOutput: (payload) =>
      dispatch(setTimeIntervalRunControlOutput(payload)),
    setTimeIntervalDataOutput: (payload) =>
      dispatch(setTimeIntervalDataOutput(payload)),
    setTimeIntervalAverageDataOutput: (payload) =>
      dispatch(setTimeIntervalAverageDataOutput(payload)),
    setTimeIntervalTimeseriesOutput: (payload) =>
      dispatch(setTimeIntervalTimeseriesOutput(payload)),
    setTimeIntervalProfilesOutput: (payload) =>
      dispatch(setTimeIntervalProfilesOutput(payload)),
    setTimeInterval3DOutput: (payload) =>
      dispatch(setTimeInterval3DOutput(payload)),
    setAveragingInterval: (payload) => dispatch(setAveragingInterval(payload)),
    setTimePeriodForAveraging: (payload) =>
      dispatch(setTimePeriodForAveraging(payload)),
    setAveragingIntervalForProfiles: (payload) =>
      dispatch(setAveragingIntervalForProfiles(payload)),
    setTimePeriodForProfilesAveraging: (payload) =>
      dispatch(setTimePeriodForProfilesAveraging(payload)),
    loadWindTurbineSettings: (payload) =>
      dispatch(loadWindTurbineSettings(payload)),
    loadSavedWindTurbineSettings: (payload) =>
      dispatch(loadSavedWindTurbineSettings(payload)),
    resetWindTurbineSettings: () => dispatch(resetWindTurbineSettings()),
    setSectionYZ: (payload) => dispatch(setSectionYZ(payload)),
    setSectionXZ: (payload) => dispatch(setSectionXZ(payload)),
    setMaskOverSurface: (payload) => dispatch(setMaskOverSurface(payload)),
    setWindTurbinePoiOptions: (payload) =>
      dispatch(setWindTurbinePoiOptions(payload)),
    setWindTurbinePoiSelected: (payload) =>
      dispatch(setWindTurbinePoiSelected(payload)),
    setWindTurbineWindTurbineOptions: (payload) =>
      dispatch(setWindTurbineWindTurbineOptions(payload)),
    setWindTurbineWindTurbineSelected: (payload) =>
      dispatch(setWindTurbineWindTurbineSelected(payload)),
    setWindTurbineDataLoaded: (payload) =>
      dispatch(setWindTurbineDataLoaded(payload)),
    setPrecursorCaseOptions: (payload) =>
      dispatch(setPrecursorCaseOptions(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(WindTurbineSetup)));

export const HelpLabel = (props) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <label
        className="form-label user-settings-form-label"
        style={{ width: "auto" }}
      >
        {props.label} {props.unit && `[${props.unit}]`}
      </label>
      <a
        title={"More information"}
        href={props.helpLink}
        target="_blank"
        style={{ cursor: "pointer", marginLeft: "6px" }}
        rel="noopener noreferrer"
      >
        <HelpCircle size={15} color={"#429c88ed"} />
      </a>
    </div>
  );
};

const helpUrl =
  "https://docs.palm-model.org/25.04/Reference/LES_Model/Namelists";
